import { memo, useMemo, useState, lazy, Suspense } from 'react';
import { projectWallMediaClient } from '@/lib/api';
import { WallAttachmentList } from '../prospect/attachments/WallAttachmentList';
import { LazyProjectAudio } from './LazyProjectAudio';

const Viewer = lazy(() => import('../prospect/attachments/WallAttachmentViewer'));
const OFFICE = new Set(['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'odt', 'ods', 'odp', 'rtf']);
const TEXT = new Set(['txt', 'csv', 'md', 'json']);
const IMAGE = new Set(['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'tif', 'tiff', 'heic', 'heif', 'svg']);

function normalize(file) {
    const filename = file.original_filename || file.filename || 'Fichier';
    const ext = filename.split('.').pop().toLowerCase();
    const kind = OFFICE.has(ext) ? 'office' : TEXT.has(ext) ? 'text' : IMAGE.has(ext) ? 'image' : ext === 'zip' ? 'archive' : ext === 'pdf' ? 'pdf' : file.kind || 'file';
    return { id: file.id, filename, kind, size: file.file_size || file.size || 0, content_type: file.mime_type || file.content_type };
}

export const ProjectAttachments = memo(function ProjectAttachments({ projectId, messageId, attachments }) {
    const client = useMemo(() => projectWallMediaClient(messageId), [messageId]);
    const files = useMemo(() => (attachments || []).map(normalize), [attachments]);
    const [selected, setSelected] = useState(null);
    return <div className="min-w-0" data-testid={`pw-attachments-${messageId}`}>
        <WallAttachmentList prospectId={projectId} noteId={messageId} files={files.filter(file => file.kind !== 'audio')} client={client} onOpen={setSelected} />
        {files.filter(file => file.kind === 'audio').map(file => <LazyProjectAudio key={file.id} projectId={projectId} file={file} client={client} />)}
        {selected && <Suspense fallback={null}><Viewer prospectId={projectId} file={selected} client={client} onClose={() => setSelected(null)} /></Suspense>}
    </div>;
});